import * as Constants from '../../constants';

import { useState, useEffect, useCallback } from 'react';

import classes from "./StocksList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import ScrollContainer from '../../components/UI/ScrollContainer';
import Card from '../../components/UI/Card';

import Loading from '../../components/UI/Loading';
import StocksFilterForm from '../../components/StocksFilterForm';

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  useGrouping: false
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

// const defaultFormAsset = { id: 0, ticker: 0, quotas: 0, price: 0 };

function StocksList(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [stocks, setStocks] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersText, setFiltersText] = useState("");
  const [stocksFiltradas, setStocksFiltradas] = useState([]);
  const [filterFormIsShown, setFilterFormIsShown] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");

  const fetchStocksHandler = useCallback(async () => {
    setIsLoading(true);
    try {
      const lastUpdateReponse = await fetch(Constants.PUBLIC_STOCKS_LAST_UPDATE);
      const lastUpdateData = await lastUpdateReponse.json();
      setLastUpdate(lastUpdateData);

      const response = await fetch(Constants.PUBLIC_STOCKS_LIST);
      if (!response.ok) {
        alert('deu pau');
        throw new Error('Something went wrong!');
      }

      const data = await response.json();

      const loadedStocks = [];
      for (let item in data) {
        const element = data[item];
        let stock = {
          id: element.id,
          ticker: element.ticker,
          setor: element.sector,
          subsetor: element.subsector,
          price: element.currentPrice,
          pL: element.pL,
          dLpL: element.dLpL,
          pvp: element.pvp,
          dy: element.dy,
          roa: element.roa,
          roe: element.roe,
          roic: element.roic,
          mL: element.mL,
          mB: element.mB,
          mO: element.mO,
          cagrR5: element.cagrR5,
          cagrL5: element.cagrL5,
          vD: element.vD,
          vM: element.vM,
          vY: element.vY
        }
        loadedStocks.push(stock);
      }
      setStocks(loadedStocks);
      setStocksFiltradas(loadedStocks);
    } catch (error) {
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchStocksHandler();
  }, [fetchStocksHandler]);

  useEffect(() => {
    if (stocks.length > 0)
      setIsLoading(false);
  }, [stocks]);

  useEffect(() => {
    let str = "";
    if (Object.keys(filters).length > 0) {
      str += '<strong style="color:#0A58CA">' + Object.keys(filters).length + ' filtros aplicados</strong>: ';
      str += (filters.ticker && filters.ticker.value && filters.ticker.value.length > 0 ? "<strong>Código</strong> contém '" + filters.ticker.value + "', " : "");
      str += (filters.setor && filters.setor.value && filters.setor.value.length > 0 ? "<strong>Setor</strong> contém '" + filters.setor.value + "', " : "");
      str += (filters.subsetor && filters.subsetor.value && filters.subsetor.value.length > 0 ? "<strong>Segmento:</strong> contém '" + filters.subsetor.value + "', " : "");
      str += "<br/>";
      str += (filters.mL && filters.mL.operator !== "" ? "<strong>Margem Líquida</strong> " + filters.mL.operator + " " + filters.mL.value + "%, " : "");
      str += (filters.dlpl && filters.dLpL.operator !== "" ? "<strong>Dívida Líquida/PL</strong> " + filters.dLpL.operator + " " + filters.dLpL.value + "%, " : "");
      str += (filters.pvp && filters.pvp.operator !== "" ? "<strong>P/VP</strong> " + filters.pvp.operator + " " + filters.pvp.value + ", " : "");
      str += (filters.dy && filters.dy.operator !== "" ? "<strong>Dividend Yield</strong> " + filters.dy.operator + " " + filters.dy.value + "%, " : "");
      str += (filters.vD && filters.vD.operator !== "" ? "<strong>Variação 1Dia</strong> " + filters.vD.operator + " " + filters.vD.value + "%, " : "");
      str += (filters.vM && filters.vM.operator !== "" ? "<strong>Variação 1Mês</strong> " + filters.vM.operator + " " + filters.vM.value + "%, " : "");
      str += (filters.vY && filters.vY.operator !== "" ? "<strong>Variação 1Ano</strong> " + filters.vY.operator + " " + filters.vY.value + "%, " : "");
      str += (filters.price && filters.price.operator !== "" ? "<strong>Preço</strong> " + filters.price.operator + " R$ " + filters.price.value + ", " : "");
      str = str.substring(0, str.length - 2);
    }
    if(str.length === 0) str = "<br/><br/>";    
    setFiltersText(str);
  }, [filters]);

  const showHideFilterFormHandler = () => {
    setFilterFormIsShown(!filterFormIsShown);
  };

  const closeFilterFormHandler = () => {
    setFilterFormIsShown(false);
  };


  const filtersHandler = (filters) => {
    setFilters(filters);
    setFilterFormIsShown(false);
    const filtered = stocks.filter(item => {
      return Object.keys(filters).every(key => {
        const filtroValor = filters[key]?.value;
        const filtroOperador = filters[key]?.operator;
        const itemValor = item[key];

        // Ignorar se o valor do filtro for undefined, vazio ou zero
        if (filtroValor === undefined || filtroValor === "" || filtroOperador === 0) {
          return true;
        }

        // Para valores string, realizar comparação parcial similar ao LIKE
        if (isNaN(itemValor) && (typeof itemValor === "string" && typeof filtroValor === "string")) {
          // console.warn(key, itemValor, filtroValor, itemValor.toLowerCase().includes(filtroValor.toLowerCase()));
          return itemValor.toLowerCase().includes(filtroValor.toLowerCase());
        } else {
          // console.warn(key, itemValor, filtroOperador, filtroValor);
          switch (filtroOperador) {
            case ">":
              return Number(itemValor) > Number(filtroValor);
            case ">=":
              return Number(itemValor) >= Number(filtroValor);
            case "<":
              return Number(itemValor) < Number(filtroValor);
            case "<=":
              return Number(itemValor) <= Number(filtroValor);
            case "=":
            default:
              return Number(itemValor) === Number(filtroValor);
          }
        }
      });

    });
    setStocksFiltradas(filtered);
  };

  const dataAtualFormatada = (dt) => {
    var data = new Date(dt);
    var dia = data.getDate().toString(),
      diaF = (dia.length === 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length === 1) ? '0' + mes : mes,
      anoF = data.getFullYear(),
      hora = (data.getHours().toString().length === 1) ? '0' + data.getHours() : data.getHours(),
      min = (data.getMinutes().toString().length === 1) ? '0' + data.getMinutes() : data.getMinutes(),
      seg = (data.getSeconds().toString().length === 1) ? '0' + data.getSeconds() : data.getSeconds();

    return diaF + "/" + mesF + "/" + anoF + " " + hora + ":" + min + ":" + seg;
  }

  return <>
    {isLoading && <Loading />}
    {!isLoading && <>
      <div className="row mainPanel">
        <div className="col col-md-12">
          <Card>
            {filterFormIsShown && <StocksFilterForm
              updateFilters={filtersHandler}
              closeFilterForm={closeFilterFormHandler}
              filters={filters}
            />}
            <div className='row'>
              <div className='col-2'>
                <Button variant="secondary" className={classes.filterButton} onClick={showHideFilterFormHandler}><FontAwesomeIcon icon={faFilter} /></Button>
                &nbsp;&nbsp;
                <small>
                  <strong>{stocksFiltradas.length}</strong> stocks encontradas.
                </small>
              </div>
              <div className='col'><small dangerouslySetInnerHTML={{ __html: filtersText }} /></div>
              <div className='col-2'>
                <b>Última atualização:</b>&nbsp;&nbsp;<small>{dataAtualFormatada(lastUpdate)}</small>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ScrollContainer>
                  <Table striped bordered hover>
                    <thead className={`fixedTableHead ${classes.fixedTableHead}`}>
                      <tr>
                        <th rowSpan="2" className="text-center">CÓDIGO</th>
                        <th rowSpan="2" className={classes.th}>Setor<br /><small>Subsetor</small></th>
                        <th rowSpan="2" className={classes.th}>Liquidez<br />Diária</th>                        
                        <th rowSpan="2" className={classes.th}>P/L</th>
                        <th rowSpan="2" className={classes.th}>Dívida<br />Líquida<br />/PL</th>
                        <th rowSpan="2" className={classes.th}>P/VP</th>
                        <th rowSpan="2" className={classes.th}>Dividend<br />Yield (12M)</th>
                        <th rowSpan="2" className={classes.th}>Margem<br />Líquida</th>
                        <th rowSpan="2" className={classes.th}>Margem<br />Bruta</th>
                        <th rowSpan="2" className={classes.th}>Margem<br />Operacional</th>
                        <th rowSpan="2" className={classes.th}>ROA</th>
                        <th rowSpan="2" className={classes.th}>ROE</th>
                        <th rowSpan="2" className={classes.th}>ROIC</th>
                        <th rowSpan="2" className={classes.th}>CAGR<br />Receita<br />5 anos</th>
                        <th rowSpan="2" className={classes.th}>CAGR<br />Lucro<br />5 anos</th>
                        <th colSpan="3" className={`${classes.blue4} text-center`}>Variação</th>
                        <th colSpan="1" rowSpan="2" className={classes.th}>Preço</th>
                      </ tr>
                      <tr>
                        <th className={classes.blue3}>1 Dia</th>
                        <th className={classes.blue2}>1 Mês</th>
                        <th className={classes.blue1}>1 Ano</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stocks.length === 0 && <tr>
                        <td colSpan='20'>Nenhum ativo cadastrado.</td>
                      </tr>
                      }
                      {
                        stocksFiltradas.map((stock) => <tr key={stock.id}>
                          <td className={classes.td + " text-center"}>
                            <span className="font-weight-bolder">{stock.ticker}</span><br />
                            <a href={`${Constants.BASE_URL_EUA_STOCK_STATUSINVEST}${stock.ticker}`} target='_blank' rel="noreferrer" title='StatusInvest'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_EUA_STOCK_YAHOOFINANCE}${stock.ticker}`} target='_blank' rel="noreferrer" title='Yahoo! Finance'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_EUA_STOCK_INVESTIDOR10}${stock.ticker}`} target='_blank' rel="noreferrer" title='Investidor10'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>
                          </td>
                          <td className={classes.td}>{stock.setor}<br /><small>{stock.subsetor}</small></td>
                          <td className={classes.td}><small>0</small></td>
                          <td className={classes.td + "" + (stock.pL < 1 ? " text-success" : "")}>{stock.pL.replace(".", ",")}</td>
                          <td className={classes.td}>{stock.dLpL !== '' && !isNaN(stock.dLpL) ? percentageFormatter.format(stock.dLpL / 100) : ""}</td>
                          <td className={classes.td + "" + (stock.pvp < 1 ? " text-success" : "")}>{stock.pvp.replace(".", ",")}</td>
                          <td className={classes.td}>{stock.dy !== '' ? percentageFormatter.format(stock.dy / 100) : ""}</td>
                          <td className={classes.td}>{stock.mL !== '' && !isNaN(stock.mL) ? percentageFormatter.format(stock.mL / 100) : ""}</td>
                          <td className={classes.td}>{stock.mB !== '' && !isNaN(stock.mB) ? percentageFormatter.format(stock.mB / 100) : ""}</td>
                          <td className={classes.td}>{stock.mO !== '' && !isNaN(stock.mO) ? percentageFormatter.format(stock.mO / 100) : ""}</td>
                          <td className={classes.td}>{stock.roa !== '' ? percentageFormatter.format(stock.roa / 100) : ""}</td>
                          <td className={classes.td}>{stock.roe !== '' ? percentageFormatter.format(stock.roe / 100) : ""}</td>
                          <td className={classes.td}>{stock.roic !== '' ? percentageFormatter.format(stock.roic / 100) : ""}</td>
                          <td className={classes.td}>{stock.cagrR5 !== '' ? percentageFormatter.format(stock.cagrR5 / 100) : ""}</td>
                          <td className={classes.td}>{stock.cagrL5 !== '' ? percentageFormatter.format(stock.cagrL5 / 100) : ""}</td>
                          <td className={classes.td + "" + (stock.vD < 0 ? " text-danger" : "")}>{stock.vD !== '' && !isNaN(stock.vD) ? percentageFormatter.format(stock.vD / 100) : ""}</td>
                          <td className={classes.td + "" + (stock.vM < 0 ? " text-danger" : "")}>{stock.vM !== '' && !isNaN(stock.vM) ? percentageFormatter.format(stock.vM / 100) : ""}</td>
                          <td className={classes.td + "" + (stock.vY < 0 ? " text-danger" : "")}>{stock.vY !== '' && !isNaN(stock.vY) ? percentageFormatter.format(stock.vY / 100) : ""}</td>
                          <td className={classes.td}>{stock.price !== '' && !isNaN(stock.price) ? usdFormatter.format(stock.price).replace('.', ',') : ""}</td>
                        </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </ScrollContainer>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row adPanel">
        <div className='col'>sdafads<br />sdafads<br />sdafads<br /></div>
      </div>
    </>
    }
  </>
}

export default StocksList;
